import './_bootstrap';
import { App } from './_vue'
import Vue from 'vue'
import VueFlatpickr from 'vue-flatpickr-component'

Vue.use(VueFlatpickr);

window.app = new App({
    el: '#app',
    data: {
        variations: [],
    }
})
